<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="代理商：">
                <el-select v-model="searchForm.agentId"  @change="getAgentPkgSoldListPageHandle" filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
           
            <el-form-item label="套餐组名称：">
                <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                    <el-option v-for="item in agentPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>            
            <el-form-item label="套餐名称：">
                <el-input  v-model="searchForm.packageName" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAgentPkgSoldListPageHandle">搜索查询</el-button>
                <!-- <el-button type="primary" @click="batchAddSoldPkg()">批量分销</el-button>
                <el-button type="primary" @click="aKeyDistribution = true">一键分销</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="pkgGroupName" label="套餐组名称"></el-table-column>
            <el-table-column prop="packageName" label="套餐名称"></el-table-column>
            <el-table-column prop="packageTypeName" label="套餐类型"></el-table-column>
            <el-table-column prop="verifyPriceRmb" label="套餐成本价"></el-table-column>         
            <el-table-column label="分销价格">
                <template slot-scope="scope">                    
                    <el-input v-if="scope.row.soldState==1" type="number" v-model="scope.row.soldPriceRmb" :value="scope.row.soldPriceRmb" @change="updateAgentSoldPercentHandle(scope.row)"></el-input>
                    <span v-else>{{ scope.row.soldPriceRmb }}</span>
                </template>                 
            </el-table-column>
            <el-table-column prop="soldStateName" label="状态"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="pkgTrandferHandle(scope.row)">{{showbtnText(scope.row.soldState)}}</el-button>
                </template>              
            </el-table-column>
        </el-table>
                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    

        <!-- 一键分销 -->
        <el-dialog title="提示" :visible.sync="aKeyDistribution" :append-to-body="true" width="600px">
            <el-form :model="searchForm">
                <el-form-item label="套餐组名称：" :label-width="formLabelWidth">
                    <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                        <el-option v-for="item in agentPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span style="color:red;">此操作会将套餐组下面所有的套餐 分销给自己下级代理商,请确保代理商的分销比列正确，避免导致分销失败。</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aKeyDistribution = false">取 消</el-button>
                <el-button type="primary" @click="aKeyDistribute">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getAgentPkgSoldListPage, pkgDistribut, pkgDistributCancel, updateSoldPercent}  from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                pkgGroupId: '',
                agentId: '',
                soldState: '',
                supplierType: '',
                packageName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            agentPkgGroup: [],          
            agentListOption: [],
            supplierOption: [],
             
            aKeyDistribution: false, //一键分销
            formLabelWidth: '120px' //一键分销内嵌表单项的宽
        }
    },
    methods: {
        showbtnText(state){
            return common.showTxtByState(state, {0: '分销', 1: '移除'})
        },        
        getAgentPkgSoldListPageHandle($event){
            if(this.searchForm.agentId === ''){
                this.$message.error("请先选择代理商");
                return;                              
            }
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm); 
            getAgentPkgSoldListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg'); 
            })
        },
        pkgTrandferHandle(row){
			let self = this;
            var data = {
                packageId: row.packageId,
                agentId: self.searchForm.agentId
            }
            if(row.soldState == 1){
                data.nextId = row.nextId;
                pkgDistributCancel(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }else{
                pkgDistribut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
        },
        updateAgentSoldPercentHandle(row){            
            var data = {
                id: row.id,
                nextId: row.nextId,
                pkgPrice: row.soldPriceRmb
            }
            updateSoldPercent(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getAgentPkgSoldListPageHandle();
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentPkgSoldListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentPkgSoldListPageHandle();
        },

        batchAddSoldPkg(){
            let data = {
                agentId: this.searchForm.agentId,
                pkgGroupIds: [this.searchForm.pkgGroupId],
            };

            common.sysRequest('pkg/sold/batchAddSoldPkg', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getAgentPkgSoldListPageHandle();
            });
        },
        
        //一键分销点击确定触发
        aKeyDistribute(){
            let data = {
                basePkgGroup: this.searchForm.pkgGroupId
            }
            if(this.searchForm.pkgGroupId){
                common.sysRequest('pkg/oneButton/sold/pkg', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.aKeyDistribution = false;
                        this.$message('正在分销中，请稍后查看分销信息');
                    }
                })
            }
            
        }
    },
    created(){
        common.getNextAgentOptsCom(this, 'agentListOption');
        common.getAgentPkgGroupListCom(this, 'agentPkgGroup');
        this.getAgentPkgSoldListPageHandle();
    }
}
</script>
<style lang="less" scoped>

</style>

